<template>
  <div class="seomain">
    <st-header
      :title="mode == '0' ? 'SZ销售订单' : 'HK销售订单'"
      :back-able="true"
			:more-op="[{ val: 'download', title: '下载销售单' }, { val: 'startbatch', title: '批量处理' }]"
			@command="headercommand"
    >
      <template slot="header-right">
        <span @click="addOrder()">
          <i class="el-icon-circle-plus"></i>
        </span>
      </template>
    </st-header>
    
    <ul class="tab-tilte four">
      <li
        v-for="(item, index) in tabs"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ item.title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <div class="keyword">
      <div class="keyword-search-panel">
        <van-search
          v-model="order_code"
          shape="round"
          show-action
          background="transparent"
          placeholder="请输入订单号搜索"
          @search="onSearch"
          @cancel="onCancel"
        />
      </div>
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="type == 4" class="st-list-box pan-3">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				  <div class="st-list" v-for="(v, k) in stlist4" :key="v.id" :index="k">
				    <div class="st-list-top st-list-top-with-action">
							<div class="t-tit">{{ v.ordercode }}</div>
							<div class="order-del-btn" @click="del(v.id)"><van-icon name="delete" /></div>
				    </div>
				    <div class="st-list-main"
				    	@touchstart="touchstart"
				    	@touchmove="touchmove"
				    	@touchend="touchend"
				    	@click="checkItem(v.id)"
				    >
							<div class="list-checkbox" v-if="touchLong">
								<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
								<van-checkbox :value="checkList[v.id]"></van-checkbox>
							</div>
				      <p>订单金额：{{ v.amount }}</p>
				      <p>产品数量：{{ v.total }}</p>
				      <p>订单状态：{{ v.status }}</p>
				      <p>付款方式：{{ v.settlementtype }}</p>
				      <p>支付方式：{{ v.paytype }}</p>
				      <p>付款状态：{{ formatPayStatus(v.paystatus) }}</p>
				      <p>下单时间：{{ v.createtime }}</p>
				      <p>客户名称：{{ v.receiver }}</p>
				      <p>
				        客户电话：<a :href="'tel:' + v.phone"> {{ v.phone }}</a>
				      </p>
				      <p>收获地址：{{ v.city }}{{ v.area }}{{ v.address }}</p>
				    </div>
						<div style="display: flex;justify-content: space-around;flex-wrap:wrap;gap: 10px;">
							<div class="st-list-bottom-xs st-btn-2" v-if="v.status == '上级已审批'" style="background: #355e8e;">
							  <router-link :to="'/common/approveDetail/1?id=' + v.id" class="st-opt-btn">审批详情</router-link>
							</div>
							<div class="st-list-bottom-xs st-btn-2">
							  <router-link :to="'/saleo/detail/' + v.id" class="st-opt-btn">查看订单详情</router-link>
							</div>
							<div class="st-list-bottom-xs st-btn-2" style="background-color: orange;">
								<router-link :to="'/sale/add/' + v.id + '?mode=' + mode" class="st-opt-btn">编辑</router-link>
							</div>
							<div class="st-btn-2" v-if="v.status == '待审批'">
								<van-button @click="approval(v.id)" type="primary" class="st-opt-btn" style="width: 100%;">提交申请</van-button>
							</div>
							
						</div>
				   
				  </div>
				</van-list>
			</div>
			<div v-show="type == 0" class="st-list-box pan-3">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
            </div>
            <div class="st-list-main"
            	@touchstart="touchstart"
            	@touchmove="touchmove"
            	@touchend="touchend"
            	@click="checkItem(v.id)"
            >
            	<div class="list-checkbox" v-if="touchLong">
            		<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
            		<van-checkbox :value="checkList[v.id]"></van-checkbox>
            	</div>
              <p>订单金额：{{ v.amount }}</p>
              <p>产品数量：{{ v.total }}</p>
              <p>订单状态：{{ v.status }}</p>
              <p>付款方式：{{ v.settlementtype }}</p>
              <p>支付方式：{{ v.paytype }}</p>
              <p>付款状态：{{ formatPayStatus(v.paystatus) }}</p>
              <p>下单时间：{{ v.createtime }}</p>
              <p>客户名称：{{ v.receiver }}</p>
              <p>
                客户电话：<a :href="'tel:' + v.phone"> {{ v.phone }}</a>
              </p>
              <p>收获地址：{{ v.city }}{{ v.area }}{{ v.address }}</p>
            </div>
            <div class="st-list-bottom-xs">
              <router-link :to="'/saleo/detail/' + v.id" class="st-opt-btn">查看订单详情</router-link>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="type == 1" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.ordercode }}</div>
            </div>
            <div class="st-list-main"
            	@touchstart="touchstart"
            	@touchmove="touchmove"
            	@touchend="touchend"
            	@click="checkItem(v.id)"
            >
            	<div class="list-checkbox" v-if="touchLong">
            		<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
            		<van-checkbox :value="checkList[v.id]"></van-checkbox>
            	</div>
              <p>订单金额：{{ v.amount }}</p>
              <p>产品数量：{{ v.total }}</p>
              <p>订单状态：{{ v.status }}</p>
              <p>付款方式：{{ v.settlementtype }}</p>
              <p>付款状态：{{ formatPayStatus(v.paystatus) }}</p>
              <p>下单时间：{{ v.createtime }}</p>
              <p>发货时间：{{ v.shiptime }}</p>
              <p>物流公司：{{ v.logisticser }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.courier }}</p>
              <p>物流状态：{{ v.logistics_status }}</p>
              <p>客户名称：{{ v.receiver }}</p>
              <p>
                客户电话：<a :href="'tel:' + v.phone"> {{ v.phone }}</a>
              </p>
              <p>收获地址：{{ v.city }}{{ v.area }}{{ v.address }}</p>
            </div>
            <div class="st-list-bottom-xs">
              <router-link :to="'/saleo/detail/' + v.id" class="st-opt-btn">查看订单详情</router-link>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="type == 2" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="v.id" :index="k">
            <div class="st-list-top st-list-top-with-status">
              <div class="t-tit">{{ v.ordercode }}</div>
              <div class="t-status">{{ formatPayStatus(v.paystatus) }}</div>
            </div>
            <div class="st-list-main"
            	@touchstart="touchstart"
            	@touchmove="touchmove"
            	@touchend="touchend"
            	@click="checkItem(v.id)"
            >
            	<div class="list-checkbox" v-if="touchLong">
            		<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
            		<van-checkbox :value="checkList[v.id]"></van-checkbox>
            	</div>
              <div class="st-summary-row">
                <div class="st-summary-card">
                  <div class="st-summary-label">订单金额</div>
                  <div class="st-summary-value">{{ v.amount || '--' }}</div>
                </div>
                <div class="st-summary-card">
                  <div class="st-summary-label">产品数量</div>
                  <div class="st-summary-value">{{ v.total || '--' }}</div>
                </div>
              </div>
              <div class="st-field"><span class="st-field-label">订单状态</span><span class="st-field-value">{{ v.status || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">付款方式</span><span class="st-field-value">{{ v.settlementtype || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">支付方式</span><span class="st-field-value">{{ v.paytype || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">付款状态</span><span class="st-field-value">{{ formatPayStatus(v.paystatus) }}</span></div>
              <div class="st-field"><span class="st-field-label">下单时间</span><span class="st-field-value">{{ v.createtime || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">发货时间</span><span class="st-field-value">{{ v.shiptime || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">签收时间</span><span class="st-field-value">{{ v.receipttime || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">物流公司</span><span class="st-field-value">{{ v.logisticser || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">物流单号</span><span class="st-field-value st-link-value" @click.stop="getExInfo(v.id)">{{ v.courier || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">物流状态</span><span class="st-field-value">{{ v.logistics_status || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">客户名称</span><span class="st-field-value">{{ v.receiver || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">客户电话</span><span class="st-field-value"><a :href="'tel:' + v.phone">{{ v.phone || '--' }}</a></span></div>
              <div class="st-field"><span class="st-field-label">收货地址</span><span class="st-field-value">{{ v.city }}{{ v.area }}{{ v.address }}</span></div>
            </div>
            <div class="st-list-bottom-2">
              <div class="st-action-wrap">
                <div class="st-list-bottom-xs st-action-view">
                  <router-link :to="'/saleo/detail/' + v.id" class="st-opt-btn">查看订单详情</router-link>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="type == 3" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist3" :key="v.id" :index="k">
            <div class="st-list-top st-list-top-with-status">
              <div class="t-tit">{{ v.ordercode }}</div>
              <div class="t-status">{{ formatPayStatus(v.paystatus) }}</div>
            </div>
            <div class="st-list-main"
            	@touchstart="touchstart"
            	@touchmove="touchmove"
            	@touchend="touchend"
            	@click="checkItem(v.id)"
            >
            	<div class="list-checkbox" v-if="touchLong">
            		<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
            		<van-checkbox :value="checkList[v.id]"></van-checkbox>
            	</div>
              <div class="st-summary-row">
                <div class="st-summary-card">
                  <div class="st-summary-label">订单金额</div>
                  <div class="st-summary-value">{{ v.amount || '--' }}</div>
                </div>
                <div class="st-summary-card">
                  <div class="st-summary-label">产品数量</div>
                  <div class="st-summary-value">{{ v.total || '--' }}</div>
                </div>
              </div>
              <div class="st-field"><span class="st-field-label">订单状态</span><span class="st-field-value">{{ v.status || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">付款方式</span><span class="st-field-value">{{ v.settlementtype || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">支付方式</span><span class="st-field-value">{{ v.paytype || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">付款状态</span><span class="st-field-value">{{ formatPayStatus(v.paystatus) }}</span></div>
              <div class="st-field"><span class="st-field-label">下单时间</span><span class="st-field-value">{{ v.createtime || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">发货时间</span><span class="st-field-value">{{ v.shiptime || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">签收时间</span><span class="st-field-value">{{ v.receipttime || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">物流公司</span><span class="st-field-value">{{ v.logisticser || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">物流单号</span><span class="st-field-value st-link-value" @click.stop="getExInfo(v.id)">{{ v.courier || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">物流状态</span><span class="st-field-value">{{ v.logistics_status || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">客户名称</span><span class="st-field-value">{{ v.receiver || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">客户电话</span><span class="st-field-value"><a :href="'tel:' + v.phone">{{ v.phone || '--' }}</a></span></div>
              <div class="st-field"><span class="st-field-label">收货地址</span><span class="st-field-value">{{ v.city }}{{ v.area }}{{ v.address }}</span></div>
            </div>
            <div class="st-list-bottom-2">
              <div class="st-action-wrap">
                <div class="st-list-bottom-xs st-action-view">
                  <router-link :to="'/saleo/detail/' + v.id" class="st-opt-btn">查看订单详情</router-link>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
			
			<batch-btn
				v-if="touchLong"
				:options="batchBtnOptions[type]"
				@command="batchCommand"
			></batch-btn>
		</div>
    <van-dialog v-model="show" show-cancel-button @confirm="edit_st2()">
      <div class="mix-detail-box">
        <h2>确认收款</h2>
        <p>订单号：{{ oneinfo.ordercode }}</p>
      </div>
    </van-dialog>

    <van-dialog class="exDialog" ref="exDialog" v-model="exShow" :title="exDialogTitle">
      <van-steps direction="vertical" :active="0" active-color="#fa6e09">
        <van-step v-for="(item, index) in exDataList" :key="index">
          <h3>{{ item.time }}</h3>
          <p>{{ item.step }}</p>
        </van-step>
      </van-steps>
    </van-dialog>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import BatchBtn from "@/components/layout/BatchBtn.vue";
export default {
  components: {
    "st-header": StHeader,
		'batch-btn': BatchBtn,
  },
  props: {},
	inject: ['reload'],
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
			tabs: [
				{ title: '待审核', type: 4 },
				{ title: '待出库', type: 0 },
				{ title: '待发货', type: 1 },
				{ title: '待收款', type: 2 },
				{ title: '已完成', type: 3 },
			],
      cur: 0,
			type: 0,
      show: !1,
			
			mode: this.$route.params.mode,
      oneinfo: {},
      stlist0: [],
      stlist1: [],
      stlist2: [],
      stlist3: [],
      stlist4: [],
      exShow: false,
      exDataList: [], // 物流信息
      exDialogTitle: "",
      order_code: "", // 关键字搜索
			
			// 批量操作相关
			checkList: {},
			batchBtnOptions: {},
			touchLong: false,
      touchTimeOut: null,
			
    };
  },
  watch: {
  	touchLong: function(nv, ov) {
  		this.checkList = {};
  		this.$forceUpdate();
  	}
  },
  computed: {},
  methods: {
    formatPayStatus(status) {
      if (!status) return "--";
      return status === "待付款" ? "待收款" : status;
    },
    resetPageInteraction() {
      this.touchLong = false;
      clearTimeout(this.touchTimeOut);
      this.touchTimeOut = null;
      document.body.style.overflow = "auto";
      if (this.$toast && typeof this.$toast.clear === "function") {
        this.$toast.clear();
      }
    },
    // 添加销售单
    addOrder() {
      this.$router.push({ path: `/sale/add`, query: { mode: this.mode }});
    },
		// 删除订单
		del(id) {
			this.$confirm('您确认删除该销售单吗？').then((data) => {
				this.$post(this.$api.stGetXiaoshouDelete, {ids: id}).then((res) => {
					if (res.code == 1) {
						this.$toast.success('删除成功');
						this.reload();
					} else {
						this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
					}
				})
			}).catch((e) => {
				console.log('您取消了删除操作');
			});
		},
		
		// 撤回订单
		returnOrder(ids) {
			this.$confirm('您正在进行撤回操作，是否继续进行？').then((data) => {
				this.$post(this.$api.stSaleReturnOrder, {ids: ids}).then((res) => {
					if (res.code == 1) {
						this.$toast.success('撤回成功');
						this.reload();
					} else {
						this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
					}
					
				})
			}).catch((e) => {
				console.log('您取消了撤回操作');
			});
		},
    show_detail_box: function(e) {
      this.$post(this.$api.stGetXiaoshouView, { id: e }).then((res) => {
        this.oneinfo = res.data.info;
        this.activeid = res.data.info.id;
        console.log(this.activeid);
        this.show = !0;
      });
    },
		// 提交申请
		approval(id) {
			this.$post(this.$api.stGetXiaoshouApproval, {'ids': id, status: 1}).then((res) => {
				if (res.code == 1) {
					this.$toast.success('提交成功');
				} else {
					this.$toast.fail((res.msg ? res.msg : '提交异常，请稍后重试'));
				}
			});
		},
    edit_st2: function() {
      let t = this;
      this.$post(this.$api.stGetXiaoshouEdit, { id: this.activeid }).then((res) => {
        if (res.code == 200) {
          this.$toast.success("修改成功");
          this.get_st_list(t.cur);
        } else {
          this.$toast(res.msg);
        }
      });
    },
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.stlist3 = [];
			this.stlist4 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("sale_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
				this.type = this.tabs[activeIndex].type;
      }
			
			this.setBatchBtnOption();
    },
    changeActiveIndex(value) {
			this.touchLong = false;
      this.cur = value;
			this.type = this.tabs[value].type;
      window.sessionStorage.setItem("sale_activeIndex", value);
    },
    // 分页
    async onLoad() {
			let type = this.tabs[this.cur]['type'];
      let result = await this.$post(this.$api.stGetXiaoshouList, {
        order_code: this.order_code,
        status: type,
        type: this.mode,
        page: this.page,
      });
      if (!result.data.list || result.data.list.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.type].push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    // 获取物流信息
    async getExInfo(id) {
      let { logisticser, courier } = this["stlist" + this.cur].filter((item) => item.id == id)[0];
      this.exDialogTitle = logisticser + ": " + courier;
      let result = await this.$post(this.$api.stGetXiaoshouExInfo, { id });
      if (result.data.code == 1) {
        console.log(result.data.data);
        this.exDataList = result.data.data;
      } else {
        this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
      }
      this.exShow = true;
    },
    onSearch(val) {
			this.touchLong = false;
			this.$set(this, ["stlist" + this.type], []);
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {
      if (!this.order_code) return;
      this.order_code = "";
      this.touchLong = false;
      this.$set(this, ["stlist" + this.type], []);
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
		
		// #region-start 批量操作相关方法
		// 开始触屏
		touchstart() {
			this.touchTimeOut = setTimeout(() => {
				this.touchLong = true;
			}, 2500)
		},
		touchmove() {
			clearTimeout(this.touchTimeOut);
		},
		touchend() {
			clearTimeout(this.touchTimeOut);
		},
		
		// 勾选
		checkItem(id) {
			this.checkList[id] = !this.checkList[id];
			this.$forceUpdate();
		},
		getCheckIds() {
			let ids = [];
			for (let i in this.checkList) {
				if (this.checkList[i]) {
					ids.push(i);
				}
			}
			
			return ids;
		},
		// 设置 批量操作的按钮
		setBatchBtnOption() {	
			let options = {};
			let oprator = {
				"contract": { text: '销售合同', value: 'geneSalesContract' },
				"invoice": { text: '申请打印发票', value: 'applyInvoice' },
				"return": { text: '撤回', value: 'returnOrder' },
			};
			let option = [
				{ text: '操作', children: [],
				}
			];
			
			for(let tit in this.tabs) {
				let v = this.tabs[tit];
				let children = [];
				if (v.type == 0) {
					options[v.type] = JSON.parse(JSON.stringify(option));
					children = ['contract', 'return', 'invoice'];
				}  else if (v.type == 1) {
					options[v.type] = JSON.parse(JSON.stringify(option));
					children = ['contract', 'return', 'invoice'];
				} else if (v.type == 2) {
					options[v.type] = JSON.parse(JSON.stringify(option));
					children = ['contract', 'return', 'invoice'];
				} else if (v.type == 3) {
					options[v.type] = JSON.parse(JSON.stringify(option));
					children = ['contract'];
				} else if (v.type == 4) {
					children = [];
				}	
	
				children.forEach((child) => {
					if (options[v.type]) {
						options[v.type][0].children.push(oprator[child]);
					}
					
				})
			}
			this.batchBtnOptions = options;
		},
		// 批量处理
		batchCommand(sign, params) {
			if (sign == 'cancel') {
				this.touchLong = false;
				return;
			}
			
			let checkedIds = this.getCheckIds();
			if (!checkedIds || Object.keys(checkedIds).length <= 0) {
				this.$toast.fail('请选择销售单');
				return;
			}
		
			// 生成销售合同
			if (sign == 'geneSalesContract') {
				this.$post(this.$api.stSaleGeneContract, {ids: checkedIds}).then((res) => {
					// let route = "/pdf/" + encodeURIComponent(res.data);
					// this.goUrl(route);
					if (res.code === 1) {
							window.location.href = res.data;
					} else {
						this.$toast.fail(res.msg);
					}
					
				}).catch((err) => {
					console.log(err)
				});
			} else if (sign == "applyInvoice") { // 打印发票申请
				this.$post(this.$api.stSalesApplyInvoice, {ids: checkedIds}).then((res) => {
					// let route = "/pdf/" + encodeURIComponent(res.data);
					// this.goUrl(route);
					if (res.code === 1) {
							window.location.href = res.data;
					} else {
						this.$toast.fail(res.msg);
					}
					
				}).catch((err) => {
					console.log(err)
				});
			} else if (sign == "returnOrder") { // 撤回
				this.returnOrder(checkedIds);
				return;
			}
		},
		// #region-edn 批量操作相关方法
		
		// 更多里的操作
		headercommand(val) {
			this[val]();
		},
		/**
		 * 下载采购单
		 */
		async download() {
			let type = this.tabs[this.cur]['type'];
			let params = {
			  order_code: this.order_code,
			  status: type,
			  type: this.mode,
				token: window.localStorage.getItem("sto_user_token"),
			}
			
			await this.$post(this.$api.stSalesDownload, params).then((res) => {
				window.location.href = res.data;
			})
			
		},
		
		
		// 开启批量模式
		startbatch() {
			this.touchLong = true;
		},
  },
  created() {
    this.resetPageInteraction();
    this.init();

    let type = this.$route.params.type;
    if (type == 0) {
      window.h5sdk && window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "我的销售单" });
      });
    } else if (type == 1) {
      window.h5sdk && window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "我的租赁单" });
      });
    } else if (type == 2) {
      window.h5sdk && window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "我的海外单" });
      });
    } else if (type == 3) {
      window.h5sdk && window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "我的寄售单" });
      });
    } else if (type == 4) {
      window.h5sdk && window.h5sdk.ready(function() {
        window.h5sdk.biz.navigation.setTitle({ title: "我的投资单" });
      });
    }
  },
  mounted() {
    this.resetPageInteraction();
  },
  beforeDestroy() {
    this.resetPageInteraction();
  },
};
</script>
<style lang="scss" scoped>
.st-list-box{
	margin: 0px 24px;
	.st-list {
		border-radius: 5px;
	}
}
.st-header-right {
  .el-icon-circle-plus {
    font-size: 30px;
    transform: translateY(7px);
    color: rgba(42, 130, 228, 1);
  }
}

.st-list-bottom-xs {
  border-radius: 5px;
  font-size: 14px;
}

.keyword {
  position: fixed;
  margin-bottom: 8px;
  width: 100%;
  top: calc(106px + constant(safe-area-inset-top));
  top: calc(106px + env(safe-area-inset-top));
  background-color: transparent;
}

.keyword-search-panel {
  margin: 0 12px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eceff5;
  overflow: hidden;
  box-shadow: none;
}

.keyword-search-panel .van-search {
  padding-left: 16px;
  padding-right: 16px;
}
.four li {
  width: 20%;
  min-width: 0;
  flex: 1 1 0;
}
.st-list-bottom-xs {
  background: #677588;
}
.pan-2 .t-tit {
  border-left: 3px solid #43cf7c;
}
.pan-3 .t-tit {
  border-left: 3px solid #ff5733;
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}

.st-list-main {
	position: relative;
  padding-top: 4px;
  padding-bottom: 4px;
  .st-summary-row {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
  }
  .st-summary-card {
    flex: 1;
    min-width: 0;
    padding: 10px 12px;
    border-radius: 10px;
    background: #f7f9fc;
  }
  .st-summary-label {
    color: #8a93a3;
    font-size: 12px;
    line-height: 1.2;
  }
  .st-summary-value {
    margin-top: 6px;
    color: #394150;
    font-size: 16px;
    font-weight: 600;
    word-break: break-all;
  }
  .st-field {
    display: flex;
    align-items: flex-start;
    padding: 6px 0;
    font-size: 14px;
    line-height: 1.5;
    border-bottom: 1px dashed #f1f3f7;
  }
  .st-field:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
  .st-field-label {
    flex: 0 0 84px;
    color: #7d8697;
  }
  .st-field-label::after {
    content: "：";
  }
  .st-field-value {
    flex: 1;
    min-width: 0;
    color: #394150;
    word-break: break-all;
  }
  .st-link-value {
    color: #2a82e4;
  }
	.list-checkbox {
		position: absolute;
		top: 10px;
		right: 20px;
	}
}
</style>
<style lang="scss" scoped>
.tab-tilte.four {
  display: flex;
  overflow-x: hidden;
  height: 62px;
  min-height: 62px;
  align-items: center;
  padding: 2px 0 4px;
  box-sizing: border-box;
}
.tab-tilte.four .text-center {
  flex: 1 1 0;
  min-width: 0;
  height: 100%;
  padding: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-tilte.four .text-center span {
  font-size: 14px;
  line-height: 1;
}

.tab-tilte.four .active span {
  display: block;
  margin: 0 4px;
  padding: 10px 10px;
  border-radius: 999px;
}

.tab-content-list {
  padding-top: 134px;
}
.st-btn-3 {
	width: 30%;
	height: 50%;
	border-radius: 5px;
}
.st-btn-2 {
	min-width: 45%;
	flex: 1;
	height: 42px;
}

.st-list-top-with-action {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .t-tit {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 8px;
  }

  .order-del-btn {
    flex: 0 0 34px;
    width: 34px;
    text-align: center;
    color: #f2484b;
    font-size: 24px;
    line-height: 1;
  }
}

.st-list-top-with-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.st-list-top-with-status .t-tit {
  flex: 1;
  min-width: 0;
}

.st-list-top-with-status .t-status {
  flex: 0 0 auto;
  color: #2a82e4;
  font-weight: 600;
}

.st-list-bottom-2 {
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
}

.st-action-wrap {
  flex: 1;
  padding: 0 8px;
  height: 44px;
  min-width: 0;
}

.st-list-bottom-2 > .st-action-wrap,
.st-list-bottom-2 > .st-action-btn {
  flex: 1 1 0;
  min-width: 0;
}

.st-action-btn,
.st-action-wrap .st-list-bottom-xs {
  margin-top: 0;
  height: 42px;
  line-height: 42px;
  border-radius: 5px;
}

.st-action-btn {
  flex: 1 1 0;
  width: auto;
}

.st-action-wrap .st-list-bottom-xs {
  width: 100%;
  padding: 0;
}

.st-action-wrap .st-opt-btn {
  display: block;
  width: 100%;
  margin-top: 8px;
  padding-top: 14px;
}

.st-action-view {
  background-color: #677588;
}

</style>
